class MissingKeyError extends Error {
  constructor(message: string) {
    super(message);
    this.message = message;
    this.name = 'MissingKeyError';
  }
}

export default MissingKeyError;
